module.exports = __webpack_public_path__ + "img/Token_CBX-01.e39dfd1.png";